export default "__VITE_ASSET__VC8LBFnG__"